import { videoFileShortFormats } from "@constants/index";

export function isValidVideoPath(filePath: string): boolean {
  // Create a regular expression pattern to match any of the video extensions at the end of the string
  // eslint-disable-next-line no-useless-escape
  const pattern = new RegExp(`\.(${videoFileShortFormats.join('|')})$`, 'i');

  return pattern.test(filePath);
}
